var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "yxt-drawer",
        {
          attrs: {
            "destroy-on-close": true,
            size: "640px",
            title: _vm.$t("pc_ac_lbl_import_outer").d("外部账号导入"),
            visible: _vm.showVisitorDrawer,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showVisitorDrawer = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _c("yxtbiz-visitor-importor", {
            on: { getUserList: _vm.getUserList },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("yxt-button", { on: { click: _vm.closeDrawer } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("pc_ac_btn_cancel").d("取消")) +
                    "\n      "
                ),
              ]),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("pc_ac_btn_sure").d("确定")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }